import { ListItem } from '@tableau/widgets';
import { Messages } from '../../../gen-src/Localize';

export namespace SortOptions {
  export function getRelevancyItem(): ListItem {
    return {
      value: 'relevancy',
      content: Messages.SortOptionRelevance(),
    };
  }

  export function getHitsMediumSpanTotalItem(): ListItem {
    return {
      value: 'hitsMediumSpanTotal',
      content: Messages.SortOptionPopularity(),
    };
  }

  export function getDownstreamWorkbookCountItem(): ListItem {
    return {
      value: 'downstreamWorkbookCount',
      content: Messages.SortOptionPopularity(),
    };
  }

  export function getHitsTotalItem(): ListItem {
    return {
      value: 'hitsTotal',
    };
  }
}
